import { render } from "./catalogArticleDetail.vue?vue&type=template&id=b5d4c9f8&scoped=true"
import script from "./catalogArticleDetail.vue?vue&type=script&lang=js"
export * from "./catalogArticleDetail.vue?vue&type=script&lang=js"

import "./catalogArticleDetail.vue?vue&type=style&index=0&id=b5d4c9f8&lang=scss&scoped=true"
import "./catalogArticleDetail.vue?vue&type=style&index=1&id=b5d4c9f8&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5d4c9f8"]])

export default __exports__